<template>
  <div class="container">
    <div class="selectconditons">
      <a-input
        ref="scode"
        v-model="inputGroup.scode"
        placeholder="发送号码"
        style="width: 15%; margin-right: 2%"
        @pressEnter=";(pagination.current = 1), getTableDate()"
      >
        <a-icon slot="prefix" type="mobile" />
        <a-tooltip slot="suffix" title="要查询发送号码">
          <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
        </a-tooltip>
      </a-input>
      <a-select
        default-value="请选择短信类型"
        style="width: 14%; margin-right: 1%"
        @select="chooseWhat"
        @focus="getMessageTypeOpenion()"
      >
        <a-select-option :value="value" v-for="value in messageType" :key="value.index">{{ value }}</a-select-option>
      </a-select>
      <a-input
        ref="userid"
        v-model="inputGroup.userid"
        placeholder="用户账号"
        style="width: 15%; margin-right: 2%"
        @pressEnter=";(pagination.current = 1), getTableDate()"
      >
        <a-icon slot="prefix" type="user" />
        <a-tooltip slot="suffix" title="用户账号">
          <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
        </a-tooltip>
      </a-input>
      <a-button type="primary" icon="search" @click=";(pagination.current = 1), getTableDate()">搜索</a-button>
      <a-button type="primary" icon="plus" style="margin-left: 1%" @click="openAddModal()">添加一组信息</a-button>

      <a-modal v-model="visible" :title="title" @ok="sumitUpdateIndustry()">
        <!-- 表单 start -->
        <a-row class="rowStyle">
          <a-col :span="6">
            <div class="titleLabel">
              <span style="color: red; font-size: 18px;line-height：22px;align-text:center"> * </span>
              <span style="font-weight: 500">短信类型: </span>
            </div>
          </a-col>
          <a-col :span="14">
            <a-input placeholder="Message Type" v-model="industryInfo.type" @blur="checkMessageType()" />
          </a-col>
          <a-col :span="4" v-if="showTypeNull">
            <p class="nullTips">类型必填！</p>
          </a-col>
        </a-row>
        <a-row class="rowStyle">
          <a-col :span="6">
            <div class="titleLabel">
              <span style="color: red; font-size: 18px;line-height：22px;align-text:center"> * </span>
              <span style="font-weight: 500">类型编码: </span>
            </div>
          </a-col>
          <a-col :span="14">
            <j-dict-select-tag
              class="width-100"
              dictCode="message_type_code"
              :triggerChange="false"
              placeholder="Message Type"
              v-model="industryInfo.smsType"
            />
          </a-col>
          <a-col :span="4" v-if="showTypeNull">
            <p class="nullTips">类型编码必填！</p>
          </a-col>
        </a-row>
        <a-row class="rowStyle">
          <a-col :span="6">
            <div class="titleLabel">
              <span style="color: red; font-size: 18px;line-height：22px;align-text:center"> * </span>
              <span style="font-weight: 500">用户账号: </span>
            </div>
          </a-col>
          <a-col :span="14">
            <a-input placeholder="User Account" v-model="industryInfo.userid" @blur="checkMessageAcount()" />
          </a-col>
          <a-col :span="4" v-if="showUserIdNull">
            <p class="nullTips">账号必填！</p>
          </a-col>
        </a-row>

        <a-row class="rowStyle">
          <a-col :span="6">
            <div class="titleLabel">
              <span style="color: red; font-size: 18px;line-height：22px;align-text:center"> * </span>
              <span style="font-weight: 500">用户密码: </span>
            </div>
          </a-col>
          <a-col :span="14">
            <a-input placeholder="User Password" v-model="industryInfo.password" @blur="checkMessagePassword()" />
          </a-col>
          <a-col :span="4" v-if="showPasswordNull">
            <p class="nullTips">密码必填！</p>
          </a-col>
        </a-row>

        <a-row class="rowStyle">
          <a-col :span="6">
            <div class="titleLabel">
              <span style="color: red; font-size: 18px;line-height：22px;align-text:center"> * </span>
              <span style="font-weight: 500">发送号码: </span>
            </div>
          </a-col>
          <a-col :span="14">
            <a-input placeholder="1069XXXXX" v-model="industryInfo.scode" @blur="checkMessageScode()" />
          </a-col>
          <a-col :span="4" v-if="showScodeNull">
            <p class="nullTips">号码必填！</p>
          </a-col>
        </a-row>

        <a-row class="rowStyle">
          <a-col :span="6">
            <div class="titleLabel">
              <span style="color: red; font-size: 18px;line-height：22px;align-text:center"> * </span>
              <span style="font-weight: 500">短信签名: </span>
            </div>
          </a-col>
          <a-col :span="14">
            <a-input placeholder="【短信签名】" v-model="industryInfo.signatures" @blur="checkMessageSignatures()" />
          </a-col>
          <a-col :span="4" v-if="showSignaturesNull">
            <p class="nullTips">短信签名必填！</p>
          </a-col>
        </a-row>

        <a-row class="rowStyle">
          <a-col :span="6">
            <div class="titleLabel">
              <span style="font-weight: 500">备注: </span>
            </div>
          </a-col>
          <a-col :span="14">
            <a-textarea placeholder="备注" v-model="industryInfo.memo" :rows="4" />
          </a-col>
        </a-row>
        <!-- 表单 end -->
      </a-modal>
    </div>
    <div class="selectresulttable">
      <a-table :columns="columns" :data-source="data" :pagination="false" :loading="loading" bordered>
        <span slot="action" slot-scope="text, record">
          <a-button type="link" @click="editIndustry(record)" size="small" style="margin-right: 3px">修改</a-button>
          <a-button type="link" style="color: #ff4d4f" @click="deleteIndustry(record)" size="small">删除</a-button>
        </span>
      </a-table>
      <div class="pageBar">
        <a-pagination
          style="margin-top: 1%; float: right"
          size="small"
          :current="pagination.current"
          :total="pagination.total"
          :show-total="(total, range) => `${range[0]}-${range[1]} 共 ${total} 条`"
          show-size-changer
          show-quick-jumper
          :showSizeChanger="true"
          :pageSize="pagination.pageSize"
          :pageSizeOptions="pagination.pageSizeOptions"
          @change="onChange"
          @showSizeChange="showSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { delIndustry, updateIndustry, addIndustry, getAllIndustry, getMessageType } from '@/api/api'
import moment from 'moment'
import JDictSelectTag from '../../components/dict/JDictSelectTag.vue'
import JMultiSelectTag from '../../components/dict/JMultiSelectTag.vue'
//表格字段名称
const columns = [
  {
    title: '短信类型',
    dataIndex: 'type',
    key: 'type',
    width: 100,
  },
  {
    title: '类型拼音',
    dataIndex: 'pinyinType',
    key: 'pinyinType',
    width: 100,
  },
  {
    title: '用户账号',
    dataIndex: 'userid',
    key: 'userid',
    width: 80,
  },
  {
    title: '发送号码',
    dataIndex: 'scode',
    key: 'scode',
    width: 100,
  },
  {
    title: '短信签名',
    dataIndex: 'signatures',
    key: 'signatures',
    width: 100,
  },
  {
    title: '备注',
    dataIndex: 'memo',
    key: 'memo',
    width: 150,
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createDate',
    width: 80,
  },
  {
    title: '更新时间',
    dataIndex: 'updateTime',
    key: 'updateDate',
    width: 80,
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    width: 100,
  },
]

export default {
  components: { JDictSelectTag, JMultiSelectTag },
  data() {
    return {
      columns,
      data: [],
      //页码数据
      pagination: {
        current: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '15', '20'],
        pageSize: 10,
      },
      //查询参数
      inputGroup: {
        scode: '',
        type: '',
        userid: '',
      },
      //账号信息参数
      industryInfo: {
        type: '',
        userid: '',
        password: '',
        scode: '',
        memo: '',
        signatures: '',
        smsType: '',
      },
      loading: false,
      visible: false,
      addIndustryModal: false,
      isChangeIndustry: false,
      chooseIndustryID: '',
      messageType: [],
      title: '',
      showTypeNull: false,
      showUserIdNull: false,
      showPasswordNull: false,
      showScodeNull: false,
      showSignaturesNull: false,
    }
  },
  mounted() {
    this.getTableDate()
  },
  methods: {
    checkMessageType() {
      if (this.industryInfo.type == '') {
        this.showTypeNull = true
      } else {
        this.showTypeNull = false
      }
    },
    checkMessageSignatures() {
      if (this.industryInfo.signatures == '') {
        this.showSignaturesNull = true
      } else {
        this.showSignaturesNull = false
      }
    },
    checkMessageAcount() {
      if (this.industryInfo.userid == '') {
        this.showUserIdNull = true
      } else {
        this.showUserIdNull = false
      }
    },
    checkMessagePassword() {
      if (this.industryInfo.password == '') {
        this.showPasswordNull = true
      } else {
        this.showPasswordNull = false
      }
    },
    checkMessageScode() {
      if (this.industryInfo.scode == '') {
        this.showScodeNull = true
      } else {
        this.showScodeNull = false
      }
    },
    //获取选择器选项
    getMessageTypeOpenion() {
      getMessageType().then((res) => {
        this.messageType = res.result.value
        this.messageType.splice(0, 0, '全部')
      })
    },
    //修改选择器选择的值
    chooseWhat(value) {
      this.inputGroup.type = value
      this.pagination.current = 1
      this.getTableDate()
    },
    openAddModal() {
      this.cleanIndustryInfo()
      this.title = '添加账户信息'
      this.visible = true
    },
    //提交修改信息
    sumitUpdateIndustry() {
      if (this.isChangeIndustry == true) {
        let sumitDate = {
          id: this.chooseIndustryID,
          memo: this.industryInfo.memo,
          password: this.industryInfo.password,
          scode: this.industryInfo.scode,
          type: this.industryInfo.type,
          userid: this.industryInfo.userid,
          signatures: this.industryInfo.signatures,
          smsType: this.industryInfo.smsType,
        }
        updateIndustry(sumitDate).then((res) => {
          if (res.success) {
            this.$message.success(res.message)
            this.visible = false
            this.cleanIndustryInfo()
            this.getTableDate()
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        this.AddIndustryOK()
      }
    },
    //添加账号信息
    AddIndustryOK() {
      let sumitDate = {
        memo: this.industryInfo.memo,
        password: this.industryInfo.password,
        scode: this.industryInfo.scode,
        type: this.industryInfo.type,
        userid: this.industryInfo.userid,
        signatures: this.industryInfo.signatures,
        smsType: this.industryInfo.smsType,
      }
      addIndustry(sumitDate).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.visible = false
          this.cleanIndustryInfo()
          this.getTableDate()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    editIndustry(industry) {
      //先赋值
      this.industryInfo.memo = industry.memo
      this.industryInfo.password = industry.password
      this.industryInfo.scode = industry.scode
      this.industryInfo.type = industry.type
      this.industryInfo.userid = industry.userid
      this.industryInfo.smsType = industry.smsType
      this.chooseIndustryID = industry.id
      this.industryInfo.signatures = industry.signatures

      this.showTypeNull = false
      this.showUserIdNull = false
      this.showPasswordNull = false
      this.showScodeNull = false
      this.showSignaturesNull = false
      //弹出添加信息的模态框
      this.title = '修改账户信息'
      this.visible = true
      this.isChangeIndustry = true
    },
    //清空输入框
    cleanIndustryInfo() {
      this.industryInfo.memo = ''
      this.industryInfo.password = ''
      this.industryInfo.scode = ''
      this.industryInfo.type = ''
      this.industryInfo.userid = ''
      this.industryInfo.signatures = ''
      this.isChangeIndustry = false
    },
    //删除账号信息二步确认
    deleteIndustry(industry) {
      this.$antdConfirm({
        title: '是否删除短信类型为' + industry.type + '的账户信息?',
        content: (h) => (
          <div style="color:red;">
            <a-icon type="info-circle" style="margin-right:10px" />
            删除操作不可恢复的哦
          </div>
        ),
        okText: '是',
        okType: 'danger',
        cancelText: '点错啦',
        onOk: () => {
          this.doDelete(industry.id)
        },
        onCancel: () => {
          this.$message.success('感谢您的仁慈！')
        },
      })
    },
    //删除信息账号
    doDelete(id) {
      let delDate = {
        id: id,
      }
      delIndustry(delDate).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.getTableDate()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //页面换页重新获取表格数据
    onChange(page, pageSize) {
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      this.getTableDate()
    },
    //页面容量修改时重新获取表格数据
    showSizeChange(current, size) {
      this.pagination.current = current
      this.pagination.pageSize = size
      this.getTableDate()
    },
    //获取表格数据
    getTableDate() {
      this.loading = true
      let parms = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        scode: this.inputGroup.scode,
        type: this.inputGroup.type,
        userid: this.inputGroup.userid,
      }
      getAllIndustry(parms).then((res) => {
        this.data = res.result.records
        this.pagination.current = res.result.current
        this.pagination.total = res.result.total
        this.loading = false
      })
    },
  },
}
</script>

<style scoped>
.container {
  background-color: #ffffff;
  height: 100%;
  width: 100%;
}
.selectconditons {
  padding-top: 1%;
  padding-left: 1%;
  background-color: #ffffff;
}
.selectresulttable {
  padding: 0.5%;
  background-color: #ffffff;
}
.pageBar {
  width: 100%;
  height: 3rem;
  background-color: #ffffff;
}
.titleLabel {
  float: right;
  padding-right: 10%;
}
.nullTips {
  color: red;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
  margin: auto;
}
.rowStyle {
  height: 100%;
  margin-top: 15px;
}
.width-100 {
  width: 100%;
}
</style>
